module.exports = __webpack_public_path__ + "static/img/blanking.3888546.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blanking.png
// module id = wXG9
// module chunks = 1